import script from "./OverTimeDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverTimeDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./OverTimeDetailModal.vue?vue&type=style&index=0&id=74ad96d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ad96d0"]])

export default __exports__